import { replaceCharWith } from "@website-builder/utilities-index";

export default ({}, { context: { full_slug } }) => {
	let breadCrumbs = full_slug.split("/");
	let slug = "";
	breadCrumbs = breadCrumbs.map((name) => {
		slug += `${name}/`;
		return {
			label: replaceCharWith(/-/g, " ", name),
			link: {
				value: `/${slug}`,
				target: "_self",
				type: "external",
			},
		};
	});

	return {
		breadCrumbs,
	};
};
